import {
  addToBasket,
  addVoucher,
  getBasket,
  getBasketLinesCount,
  removeFromBasket,
  updateLineItem,
} from '@/services/basket'
import {isRounded} from "@/lib/productAttrs";
import {expanded} from '@/lib/selectedProduct';
import {getCookie, setCookie} from 'tiny-cookie';
import {lineAddedToCart} from "@/lib/track/events";

let futureVoucher = null;
try {
  futureVoucher = getCookie('futureVoucher', JSON.parse) || null;
} catch(e) {
  console.error(e);
}

export default {
  state: {
    basketLoaded: false,
    basketUrl: null,
    basketLines: [],
    numBasketLines: 0,
    basketVoucher: null,
    subtotalPrice: 0, // Price of line items only
    totalPrice: 0,  // Price of line items, shipping, tax
    selected: null, // selected line
    futureVoucher
  },
  mutations: {
    setBasketData(state, basketData) {
      state.basketUrl = basketData.url;
      state.basketLines = basketData.lines;
      state.numBasketLines = basketData.lines.length;
      // We only handle one basket voucher. Set to undefined if no vouchers are present.
      state.basketVoucher = basketData.voucher_discounts[0];
      console.log('basketData:', basketData);
      state.basketLoaded = true;
      if (state.selected) {
        state.selected = state.basketLines.find(line => line.url === state.selected.url);
      }
    },
    setNumBasketLines(state, numBasketLines) {
      state.numBasketLines = numBasketLines;
    },
    removeLine(state, lineItem) {
      var index = state.basketLines.findIndex((curLine) => curLine.url === lineItem.url);
      if (index === -1) {
        // We expected to find the line, this is an error
        console.error("Unable to find line to update!");
        throw "Unable to find line to update!";
      }
      state.basketLines.splice(index, 1);
      state.numBasketLines -= 1;
    },
    updateLine(state, lineItem) {
      var index = state.basketLines.findIndex((curLine) => curLine.url === lineItem.url);
      if (index === -1) {
        // We expected to find the line, this is an error
        throw "Unable to find line to update!";
      }

      // Ensure the lineItem we have has expanded data such as product
      if (typeof lineItem.product === 'string') {
        let curLine = state.basketLines[index];
        if (typeof curLine.product !== 'object' || curLine.product.url !== lineItem.product) {
          throw "New line item needs expanded product info";
        }
        lineItem.product = curLine.product;
      }

      // Replace line that we found. Use splice so Vue reacts properly
      state.basketLines.splice(index, 1, lineItem);
      if (state.selected && state.selected.url === lineItem.url) {
        state.selected = lineItem;
      }
    },
    setSelectedLine(state, lineFilter) {
      state.selected = _.find(state.basketLines, lineFilter);
      console.log('setSelectedLine', lineFilter, '->', state.selected);
    },
    updateBasketThumbnail(state, {designId, pageNum, dataUrl}) {
      let line = state.basketLines.find(line => +line.designId === +designId);
      if (!line) return;
      line.preview_urls[pageNum] = dataUrl;
    },
    setFutureVoucher(state, code) {
      console.log('futureVoucher')
      state.futureVoucher = code;
      setCookie('futureVoucher', code, JSON.stringify);
    }
  },

  actions: {
    async loadBasket(context) {
      if (!context.state.basketLoaded) {
        return this.dispatch('reloadBasket');
      }
    },
    async getNumBasketLines({ commit }) {
      commit('setNumBasketLines', await getBasketLinesCount())
    },
    async loadSelectedLine(context, lineFilter) {
      await context.dispatch('loadBasket');
      context.commit('setSelectedLine', lineFilter);
    },
    async clearSelectedLine({dispatch}) {
      return dispatch('loadSelectedLine', () => false);
    },
    async reloadBasket(context) {
      var basket = await getBasket();
      context.commit('setBasketData', basket);
      context.dispatch('calcTax');
    },
    async addToCart(context, {productUrl, boxSize, designId, quantity, orderedFor}) {
      if (!productUrl || !boxSize || !quantity) throw new Error();
      designId = designId || context.getters.designId;
      const basket = await addToBasket(productUrl, quantity, designId, boxSize, orderedFor);
      context.commit('setBasketData', basket);
      context.commit('setSelectedLine', {designId});
      lineAddedToCart();
    },
    async changeNumberOfBoxes(context, {line, quantity}) {
      var result = await updateLineItem(line.url, {quantity});
      context.commit('updateLine', result);
    },
    async updateLine(context, {line, product, boxSize}) {
      if (!product) product = line.product.url;
      var result = await updateLineItem(line.url, {boxSize, product});
      context.commit('updateLine', result);
      return context.dispatch('reloadBasket');
    },
    async removeFromCart(context, line) {
      await removeFromBasket(line.url);
      context.commit('removeLine', line);
    },
    async addLineFromProductSelector({dispatch, getters}, productSelector) {
      // Design should be set. Adds line from product selector.
      let numPages = getters.designPageCount;
      let p = expanded(productSelector), productUrl = p[numPages];
      if (!productUrl) {
        // 1 page upload but only 2 page product, or vice versa
        productUrl = p[3 - numPages];
        if (numPages === 2) {
          // Product requires 1 page (eg, magnet)
          await dispatch('dropSecondPageFromDesign');
          await dispatch('showEditorMessage', 'The chosen product can only be printed on one side. The second side has been dropped.');
        }
      }
      await dispatch('addToCart', {
        productUrl,
        quantity: 1,
        boxSize: p.quantity,
        designId: getters.designId
      });
    },
    async duplicateLineAndDesign(context, line) {
      await context.dispatch('startDesignFromTemplate', line.designId);
      return context.dispatch('addToCart', {
        productUrl: line.product.url,
        boxSize: line.boxSize,
        designId: context.getters.designId,
        quantity: 1
      });
    },
    async addVoucher(context, voucherCode) {
      let result;
      try {
        result = await addVoucher(voucherCode);
        console.log('voucher:', result);
      } catch(e) {
        // Unwrap the error body
        console.error(e);
        if (e.response && e.response.data) e = e.response.data;
        if (e.non_field_errors) e = e.non_field_errors;
        if (e.vouchercode) e = e.vouchercode;
        if (e.reason) e = e.reason;
        if (e.join) e = e.join(' ');
        // Rewrite to be friendlier
        if (e === "Voucher code unknown") e = "Code not found: " + voucherCode;
        throw e;
      }
      context.dispatch('reloadBasket');
    },
    async addFutureVoucher({commit}, voucherCode) {
      // Adds a future voucher that should be applied
      // later when items are added to the basket.
      // This should be fast and not use an API call.
      commit('setFutureVoucher', voucherCode);
    },
    async applyFutureVoucher({state, dispatch}) {
      if (state.futureVoucher) {
        return dispatch('addVoucher', state.futureVoucher);
      }
    }
  },

  getters: {
    basketUrl: state => state.basketUrl,
    basketLines: state => state.basketLines,
    subtotalPrice(state) {
      return state.basketLines.reduce((sum, lineItem) => {
        return sum + parseFloat(lineItem.price_excl_tax, 10);
      }, 0)
    },
    // NB: expects other modules to define getters.taxAmount, getters.shipAmount
    totalPrice(state, getters) {
      var tax = getters.taxAmount, ship = getters.shipAmount;
      if (tax == null || ship == null) return null;
      return getters.subtotalPrice + tax + ship;
    },
    selectedProductIsRounded: state =>  state.selected && isRounded(state.selected.product),
    selectedLine: state => state.selected,
    basketVoucher: state => state.basketVoucher,
    basketVoucherCode: state => state.basketVoucher && state.basketVoucher.voucher && state.basketVoucher.voucher.code,
    numBasketLines: state => state.numBasketLines || 0,
    simpleProductDiscount: state => {
      return {VIP2018: 1.0, EARLYBIRD: 0.5}[state.futureVoucher] || 0;
    },
    currentOrFutureVoucher: (state, getters) => getters.basketVoucherCode || state.futureVoucher,
  }
}



// WEBPACK FOOTER //
// ./src/store/basket.js